import { useState, type ReactNode, type SyntheticEvent } from "react";
import { ChevronRight } from "lucide-react";

export function OpsSettingsCollapse(props: { title: string; children: ReactNode; defaultOpen?: boolean }) {
  const [open, setOpen] = useState(Boolean(props.defaultOpen));
  function onToggle(e: SyntheticEvent<HTMLDetailsElement>) {
    setOpen(e.currentTarget.open);
  }
  return (
    <details
      className="group min-w-0 rounded-lg border border-gray-200 dark:border-zinc-700"
      open={open}
      onToggle={onToggle}
    >
      {/* Keep summary as block, not flex: Chromium lets a flex summary steal clicks from details content. */}
      <summary className="cursor-pointer list-none px-3 py-2 text-xs font-medium text-gray-700 select-none [&::-webkit-details-marker]:hidden dark:text-zinc-200">
        <span className="flex items-center gap-2">
          <ChevronRight
            className="h-3.5 w-3.5 shrink-0 text-gray-500 transition-transform group-open:rotate-90"
            aria-hidden
          />
          {props.title}
        </span>
      </summary>
      <div className="relative z-10 min-w-0 space-y-3 border-t border-gray-100 px-3 py-3 dark:border-zinc-800">
        {props.children}
      </div>
    </details>
  );
}
